var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gateway-image',{staticClass:"domain-ui-gateway-icon",class:_vm.gateway.health})}
var staticRenderFns = []

export { render, staticRenderFns }